<template>
  <div class="moreDetail">
    <q-bar class="bg-white">
      <q-btn dense flat round :to="{ name: 'MoreIndex' }">
        <i class="fas fa-chevron-left"></i>
      </q-btn>
      <div class="col text-center">{{ $t(currentMore.key) }}</div>
    </q-bar>
    <div class="q-ma-md" v-html="currentMore.value"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'MoreDetail',
  computed: {
    ...mapState({ currentMore: (state) => state.more.currentMore }),
  },
};
</script>
